import { observer } from "mobx-react-lite";
import { useTran } from "@/hooks";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { getLabelList, getOptionLabel } from "@/lib/utils";
import {
  LOCATION_OPTIONS,
  INDUSTRIAL_CLASSIFICATION,
  KEY_IMPROVEMENT,
} from "@/lib/constants";
import { useCompanyStore } from "../hooks";

const CompanySetupSummary = observer(() => {
  const { t } = useTran();
  const { form, setStep } = useCompanyStore();

  const rows = [
    { label: t("Company Name"), value: form.companyName || "—", step: 1 },
    {
      label: t("Country"),
      value: getOptionLabel(form.country, LOCATION_OPTIONS, "—"),
      step: 1,
    },
    {
      label: t("Industry"),
      value: getOptionLabel(form.industry, INDUSTRIAL_CLASSIFICATION, "—"),
      step: 2,
    },
    { label: t("Employees"), value: form.employeesRange || "—", step: 3 },
    { label: t("Revenue (USD)"), value: form.revenueRange || "—", step: 3 },
    {
      label: t("Service Countries"),
      value: getLabelList(form.serviceCountries, LOCATION_OPTIONS, "—"),
      step: 4,
    },
    {
      label: t("Objectives"),
      value: getLabelList(form.objectives, KEY_IMPROVEMENT, "—"),
      step: 4,
    },
  ];

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-foreground">
        {t("Review your details")}
      </h3>
      <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
        {rows.map((row) => (
          <Card
            key={row.label}
            className="relative border border-border bg-background p-3"
          >
            <Button
              type="button"
              variant="outline"
              size="sm"
              className="absolute right-3 top-3"
              onClick={() => setStep(row.step)}
            >
              {t("Edit")}
            </Button>
            <div>
              <p className="text-xs uppercase tracking-wide text-muted-foreground">
                {row.label}
              </p>
              <p className="mt-1 text-sm font-semibold text-foreground">
                {row.value}
              </p>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
});

export default CompanySetupSummary;
